import { provide, inject } from 'vue';
import { ClientResponseOfIEnumerableOfWishList, VariantImageVersion } from '@/b2c/shared/api/server-apis';
import { ClientResponseOfIEnumerableOfFavorite } from '@/b2b/shared/api/server-apis';
import utilities from '@/shared/utilities.service';

const provideWishlistApiScope: string = 'ProvideWishlistApiScope';
export interface ProductWishlist {
    id: number;
    name: string;
    skus: VariantImageVersion[];
    formattedDate: string;
}

export interface WishlistApi {
    get: () => Promise<ProductWishlist[]>,
    add: (id: number, sku?: string, messageId?: string) => Promise<void>,
    create: (name: string) => Promise<ProductWishlist[]>,
}

export function provideWishlistApi(get, add, create): void {
    const wishlistApi = {
        get: async() => get().then(convertToProductWishlistResponse),
        add: async(id: number, sku?: string) => sku && add(id, { sku }, getProductWishlistMessageId(id)),
        create: async(name: string) => create({ name, shared: false }).then(convertToProductWishlistResponse),
    };
    provide(provideWishlistApiScope, wishlistApi);
}

export function useWishlistApi() {
    const api = inject<WishlistApi>(provideWishlistApiScope);
    if (!api) {
        throw new Error(`No ${provideWishlistApiScope} provided`);
    }
    return api;
}

function convertToProductWishlistResponse(response: ClientResponseOfIEnumerableOfWishList & ClientResponseOfIEnumerableOfFavorite): ProductWishlist[] {
    return utilities.unwrapModel(response)?.map(({ id, name, skus, createDateTime }) => {
        return {
            id,
            name,
            skus,
            formattedDate: utilities.formatDate(createDateTime),
        };
    }) ?? [] as ProductWishlist[];
}

export function getProductWishlistMessageId(id: number) {
    return `ProductWishlistMessageId-${id}`;
}
